import { DefaultOptions } from "@tanstack/react-query";
import { isAxiosError } from "axios";

/*
 * A single global instance of the React QueryClient.
 */
export const queryConfig = {
  queries: {
    // Don't retry 401/402 — the API interceptor already redirects on these, and
    // retrying can return a different status on the retry (e.g. 402 then 401),
    // causing the interceptor to redirect twice and land the user on the wrong page.
    retry: (failureCount, error) => {
      if (isAxiosError(error) && (error.response?.status === 401 || error.response?.status === 402)) {
        return false;
      }

      return failureCount < 2;
    },
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  },
} satisfies DefaultOptions;
